export enum NotificationType {

    INFO = 'info',
    ERROR = 'error',
    SUCCESS = 'success',
    WARNING = 'warning'

}